/*
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-22 11:11:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-25 10:09:17
 */
import req from "@/utils/request";
// 业务开始的数据对接
export const siteUsabilityList = (params) => req.post("/monitor-service/m/monitor/siteUsabilityList", params);
export const siteUsabilityInfoList = (params) => req.post("/monitor-service/m/monitor/siteUsabilityInfoList", params);
export const indexColumnList = (params) => req.post("/monitor-service/m/monitor/indexColumnList", params);
export const indexColumnInfoList = (params) => req.post("/monitor-service/m/monitor/indexColumnInfoList", params);
export const urlUsabilityPageList = (params) => req.post("/monitor-service/m/monitor/urlUsabilityPageList", params);
export const urlUsabilityInfoPageList = (params) => req.post("/monitor-service/m/monitor/urlUsabilityInfoPageList", params);
export const indexColumnConfigList = (params) => req.post("/monitor-service/m/monitor/indexColumnConfigList", params);
export const columnList = (params) => req.post("/monitor-service/m/monitor/columnList", params);
export const columnConfigInfoList = (params) => req.post("/monitor-service/m/monitor/columnConfigInfoList", params);
export const columnInfoList = (params) => req.post("/monitor-service/m/monitor/columnInfoList", params);
export const tree = (params) => req.post("/site-service/m/site/column/tree", params);
export const indexColumnConfig = (params) => req.post("/monitor-service/m/monitor/indexColumnConfig", params);
export const columnConfigTree = (params) => req.post("/monitor-service/m/monitor/columnConfigTree", params);
export const columnConfig = (params) => req.post("/monitor-service/m/monitor/columnConfig", params);
export const addColumnType = (params) => req.post("/monitor-service/m/monitor/addColumnType", params);
export const exportColumnInfoList = (params) => req.down("/monitor-service/m/monitor/exportColumnInfoList", params);
export const moreList = (params) => req.post("monitor-service/m/monitor/moreList", params);
export const exportMoreList = (params) => req.down("/monitor-service/m/monitor/exportMoreList", params);
